import React, {useEffect} from 'react';
import {BrowserRouter as Router, Redirect, Route, Switch} from "react-router-dom";
import {injectDebugger} from "./utils/utils";
import HomeScreen from './screens/home/index';
import {ErrorScreen} from './screens/error/index';


function App() {
    useEffect(() => {
        initialize();
    }, []);

    async function initialize() {
        if (window['runtime_configs'].REACT_APP_ENV !== "production" && window['runtime_configs'].REACT_APP_ENV !== "prod") {
            await injectDebugger();
        }
    }

    
    return (
        <Router basename={window['runtime_configs'].PUBLIC_URL}>
            <Switch>
                <Route path={'/error'} children={<ErrorScreen/>}/>
                <Route path={'/'} children={<HomeScreen/>}/>
                {/*<Redirect to='/'/>*/}
            </Switch>
        </Router>
    );
}

export default App;
